// 📂 lib/routes.ts

export const ROUTES = {
  PAGE: {
    ROOT: '/',
    LOGIN: '/login',
    CREATE_ACCOUNT: '/crear-cuenta',
  },

  PUBLIC: {
    ROOT: `/`,
    PRODUCT_DETAIL: (slug: string, id: string) => `/${slug}/producto/${id}`,
  },

  DASHBOARD: {
    PRINCIPAL: '/app',
  },

  CLIENTS: {
    ROOT: '/app/comunidad',
    DETAIL: (id: string) => `/app/cliente/${id}`,
    CREATE: 'clientes/crear',
  },

  SALES: {
    ROOT: '/app/ventas',
    CREATE: '/app/ventas/crear',
    DETAIL: (id: string) => `/app/venta/${id}`,
  },

  CATALOG: {
    ROOT: '/app/catalogo',
    PRODUCTS: '/app/catalogo/productos',
  },

  PRODUCTS: {
    ROOT: '/app/catalogo/productos',
    DETAIL: (id: string) => `/app/productos/producto/${id}`,
  },

  CATEGORY: {
    ROOT: '/app/categorias',
    DETAIL: (id: string) => `/app/categorias/${id}`,
  },

  ACADEMY: {
    ROOT: '/app/academia',
    COURSES: '/app/academia/cursos',
    STUDENTS: '/app/comunidad?tab=students',
    STUDENT_DETAIL: (id: string) => `/app/cliente/${id}`,
    SETTINGS: '/app/academia/ajustes',
    DETAIL: (id: string) => `/app/academia/cursos/${id}`,
  },

  PROFILE: {
    ROOT: '/app/perfil',
    ANALYTICS: '/app/perfil/analiticas',
    CAMPAIGNS: '/app/perfil/campanas',
    MESSENGER: '/app/perfil/campanas/messenger',
    MESSENGER_CHAT: (phone: string) => `/app/perfil/campanas/messenger/${phone}`,
  },

  FINANCES: {
    ROOT: '/app/finanzas',
    EXPENSES: '/app/egresos',
    SETTLEMENTS: '/app/cierres',
    SETTLE: (id: string) => `/app/finanzas/cerrar/${id}`,
    SETTLEMENT_DETAIL: (id: string) => `/app/cierre/${id}`,
  },

  SETTINGS: {
    ROOT: '/app/configuracion',
    PERFIL: '/app/configuracion/perfil',
    BRANDING: '/app/configuracion/branding',
    FINANCE: '/app/configuracion/finanzas',
    CATALOG: '/app/configuracion/catalogo',
    MARKETING: '/app/configuracion/marketing',
    TRASH: '/app/configuracion/papelera',
    SECTIONS: '/app/configuracion/secciones',
  },

  PUBLIC_PROFILE: (slug: string) => `/${slug}`,
} as const;
